import { Page } from 'layouts/Page';
import { EMManagementCreate } from 'components/EMManagement/EMManagementCreate';

export const EMManagementCreatePage = () => {
	return (
		<Page title="Create EM – EAS Control Center">
			<EMManagementCreate />
		</Page>
	);
};
